import React from 'react';
import classnames from 'classnames';
import { useTheme } from '../theme';

export type VerticalListProps = {
  size?: 'medium' | 'large';
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

export const VerticalList = ({
  children,
  size,
  className,
  ...props
}: VerticalListProps): React.ReactElement => {
  const theme = useTheme();
  const classNames = classnames('airtame-vertical-list', className, {
    'airtame-vertical-list--large': size === 'large',
  });

  return (
    <section data-theme={theme} className={classNames} role="list" {...props}>
      {children}
    </section>
  );
};
